import prc80 from "../assets/img/skils-80.png";
import prc85 from "../assets/img/skils-85.png";
import prc90 from "../assets/img/skils-90.png";
import prc95 from "../assets/img/skils-95.png";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import arrow1 from "../assets/img/arrow1.svg";
import arrow2 from "../assets/img/arrow2.svg";
import colorSharp from "../assets/img/color-sharp.png"

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="skill" id="skills">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="skill-bx wow zoomIn">
                        <h2>Skills</h2>
                        <p>My skills that I have gained over the entire time of my practice and training in the field of website development.</p>
                        <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                            <div className="item">
                                <img src={prc95} alt="Image" />
                                <h5>HTML & CSS</h5>
                            </div>
                            <div className="item">
                                <img src={prc90} alt="Image" />
                                <h5>JavaScript</h5>
                            </div>
		                        <div className="item">
			                        <img src={prc95} alt="Image" />
			                        <h5>Figma</h5>
		                        </div>
		                        <div className="item">
			                        <img src={prc95} alt="Image" />
			                        <h5>SASS & SCSS</h5>
		                        </div>
		                        <div className="item">
			                        <img src={prc95} alt="Image" />
			                        <h5>Pug</h5>
		                        </div>
                            <div className="item">
                                <img src={prc90} alt="Image" />
                                <h5>Logo Design</h5>
                            </div>
		                        <div className="item">
			                        <img src={prc90} alt="Image" />
			                        <h5>Web Design</h5>
		                        </div>
		                        <div className="item">
			                        <img src={prc80} alt="Image" />
			                        <h5>React JS</h5>
		                        </div>
		                        <div className="item">
			                        <img src={prc95} alt="Image" />
			                        <h5>Tailwind CSS</h5>
		                        </div>
                        </Carousel>
                    </div>
                </div>
            </div>
        </div>
        <img className="background-image-left" src={colorSharp} alt="Image" />
    </section>
  )
}
